import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable, Type } from '@angular/core';
import { ProtoRequest } from '@lsq-frontend/angular-shared/api-service';
import { AlertService } from '@lsq-frontend/angular-shared/features/alert-service';
import { ISettings, SETTINGS } from '@lsq-frontend/angular-shared/settings';
import { ErrorMessageHelper } from '@lsq-frontend/common-ui';
import {
    ReportType,
    FilterBy,
    ReportStatus,
    DateRange,
    FileType
} from './models/reports.constants';
import { ReportCenterApiService } from './report-center-api';

@Injectable()
export class GenerateReportService extends ReportCenterApiService<GenerateReportRequest, unknown> {
    public requestType: Type<GenerateReportRequest>;
    public responseType: Type<unknown>;
    public endpointName = 'v1/generateReport';

    constructor(
        http: HttpClient,
        @Inject(SETTINGS) settings: ISettings,
        private _alertService: AlertService,
        private _errorsHelper: ErrorMessageHelper
    ) {
        super(http, settings);
    }

    public downloadFile(req: GenerateReportRequest): Promise<Blob> {
        return this._http
            .get(`${this.endpointUrl}/${req.companyRoleId}/${req.id}`, {
                headers: new HttpHeaders({ accept: 'text/plain; charset=utf-8' }),
                params: {
                    reportType: req.reportType,
                    filterBy: req.filterBy,
                    status: req.status,
                    dateRange: req.dateRange,
                    startDate: req.startDate,
                    endDate: req.endDate,
                    enableFooterTotals: `${req.enableFooterTotals}`,
                    fileType: req.fileType
                },
                responseType: 'blob'
            })
            .toPromise()
            .catch((err) => {
                this._alertService.error(this._errorsHelper.GENERIC_ERROR);
                return Promise.reject(err);
            });
    }
}

export class GenerateReportRequest extends ProtoRequest {
    public id: number;
    public companyRoleId: number;
    public reportType: ReportType;
    public filterBy: FilterBy;
    public status: ReportStatus;
    public dateRange: DateRange;
    public startDate?: string;
    public endDate?: string;
    public enableFooterTotals?: boolean;
    public fileType: FileType;

    constructor(obj?: Partial<GenerateReportRequest>) {
        super();

        this.id = obj?.id || -1;
        this.companyRoleId = obj?.companyRoleId || -1;
        this.reportType = obj?.reportType || null;
        this.filterBy = obj?.filterBy || null;
        this.status = obj?.status || ReportStatus.All;
        this.dateRange = obj?.dateRange || null;
        this.startDate = obj?.startDate || null;
        this.endDate = obj?.endDate || null;
        this.enableFooterTotals = obj?.enableFooterTotals || false;
        this.fileType = obj?.fileType || null;
    }
}
